exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.el-message-box {\n  width: 500px !important;\n  min-width: 300px !important;\n  max-width: 90vw !important;\n}\n", ""]);

// exports
